<button mat-icon-button [matMenuTriggerFor]="flagsMenu" #flagsMenuTrigger="matMenuTrigger">
    <mat-icon>flag</mat-icon>
</button>
<mat-menu #flagsMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu flags">
    <span (mouseleave)="flagsMenuTrigger.closeMenu()">      
        <button mat-menu-item   (click)="switchLanguage('de')">
            <img src="assets/img/flags/de.svg" width="20" alt="german"> 
            {{'General.Application.Languages.German' | translate}}
        </button>
    </span>
</mat-menu>